import {
    selectMainState,
    useDispatch,
    useSelector,
} from "../../../stateManagement/redux";
import { login } from "../../../stateManagement/redux/slices/shared/asyncReducers";

import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
    Box,
    Button,
    Card,
    CardActions,
    CardContent,
    CircularProgress,
    FormControl,
    IconButton,
    InputAdornment,
    InputLabel,
    OutlinedInput,
    TextField, Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useState } from "react";
import "./style.scss";

export const Login = () => {
    const dispatch = useDispatch();

    const mainState = useSelector(selectMainState);

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const onLogin = () => {
        dispatch(login(email, password));
    };

    return (
        <Grid
            container
            direction="row"
            display="flex"
            sx={{
                minHeight: "100vh", // Ocupa toda la altura de la ventana
                justifyContent: "center", // Centrado horizontal
                alignItems: "center", // Centrado vertical
                backgroundColor: "custom.background", // opcional, para dar contexto visual
            }}
        >
            <Grid
                size={{
                    xs: 12,
                    sm: 12,
                    md: 12,
                    lg: 12,
                    xl: 12,
                }}
            >
                <Card
                    sx={{
                        padding: 4,
                        borderRadius: "20px",
                        width: "75%",
                        margin: "0 auto", // por si acaso el Card necesita centrarse dentro del Grid item
                    }}
                    elevation={4}
                >
                    <CardContent>
                        <Box className="wrap-main_login_logo">
                            <Box
                                component="img"
                                src="/assets/icons/logo_without_text.svg"
                            />
                            <Box
                                component="img"
                                src="/assets/icons/logo_text.svg"
                            />
                        </Box>

                        <Box>
                            <TextField
                                id="Correo Electrónico"
                                // label="Correo Electrónico"
                                placeholder="Correo Electrónico"
                                variant="outlined"
                                size="small"
                                value={email}
                                fullWidth
                                onChange={(e) => setEmail(e.target.value)}
                                sx={{
                                    "& .MuiOutlinedInput-root": {
                                        backgroundColor: "custom.grey1",
                                        borderRadius: "10px",
                                        "&.Mui-focused": {
                                            backgroundColor: "custom.grey1",
                                        },
                                        "& fieldset": {
                                            border: "none",
                                        },
                                    },
                                    "& .MuiOutlinedInput-input": {
                                        textAlign: "center",
                                    },
                                }}
                            />

                            <FormControl
                                variant="outlined"
                                fullWidth
                                size="small"
                                sx={{
                                    "& .MuiOutlinedInput-root": {
                                        backgroundColor: "custom.grey1",
                                        borderRadius: "10px",
                                        "&.Mui-focused": {
                                            backgroundColor: "custom.grey1",
                                        },
                                        "& fieldset": {
                                            border: "none",
                                        },
                                    },
                                    "& .MuiOutlinedInput-input": {
                                        textAlign: "center",
                                    },
                                    marginTop: 2,
                                }}
                            >
                                {/* <InputLabel htmlFor="outlined-adornment-password">
                                        Contraseña
                                    </InputLabel> */}
                                <OutlinedInput
                                    size="small"
                                    // label="Contraseña"
                                    placeholder="Contraseña"
                                    value={password}
                                    onChange={(e) =>
                                        setPassword(e.target.value)
                                    }
                                    id="outlined-adornment-password"
                                    type={showPassword ? "text" : "password"}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label={
                                                    showPassword
                                                        ? "hide the password"
                                                        : "display the password"
                                                }
                                                onClick={
                                                    handleClickShowPassword
                                                }
                                                edge="end"
                                            >
                                                {showPassword ? (
                                                    <VisibilityOff />
                                                ) : (
                                                    <Visibility />
                                                )}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                />
                            </FormControl>
                        </Box>
                    </CardContent>
                    <CardActions
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            marginTop: 2,
                        }}
                    >
                        <Button
                            variant="contained"
                            onClick={onLogin}
                            fullWidth
                            sx={{
                                backgroundColor: "custom.blue2",
                                width: "45%",
                                borderRadius: "8px",
                            }}
                        >
                            {mainState.loading ? (
                                <CircularProgress color="inherit" size={20} />
                            ) : (
                                "Iniciar Sesión"
                            )}
                        </Button>
                        <Box sx={{ marginTop: 5 }}>
                            <Typography
                                variant="body1"
                                sx={{ color: "silver" }}
                            >
                                Derechos Reservados © 2026 NABEP
                            </Typography>
                        </Box>
                    </CardActions>
                </Card>
            </Grid>
        </Grid>
    );
};
